import React from "react";

const LockIcon = ({ height = 11, width = 11, className }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 11 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clip-path="url(#clip0_5539_20633)">
        <path
          d="M8.70833 5.04167H2.29167C1.78541 5.04167 1.375 5.45207 1.375 5.95833V9.16667C1.375 9.67293 1.78541 10.0833 2.29167 10.0833H8.70833C9.21459 10.0833 9.625 9.67293 9.625 9.16667V5.95833C9.625 5.45207 9.21459 5.04167 8.70833 5.04167Z"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3.20825 5.04167V3.20833C3.20825 2.60054 3.44969 2.01765 3.87947 1.58788C4.30924 1.15811 4.89213 0.916666 5.49992 0.916666C6.10771 0.916666 6.6906 1.15811 7.12037 1.58788C7.55014 2.01765 7.79159 2.60054 7.79159 3.20833V5.04167"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_5539_20633">
          <rect width="11" height="11" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default LockIcon;
